var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 39,
    viewBox: "0 0 16 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70712 21.7071C8.3166 22.0976 7.68343 22.0976 7.29291 21.7071L0.928944 15.3431C0.538419 14.9526 0.538418 14.3195 0.928943 13.9289C1.31947 13.5384 1.95263 13.5384 2.34316 13.9289L8.00001 19.5858L13.6569 13.9289C14.0474 13.5384 14.6806 13.5384 15.0711 13.9289C15.4616 14.3195 15.4616 14.9526 15.0711 15.3431L8.70712 21.7071ZM9 -2.57125e-09L9.00002 21L7.00002 21L7 2.57125e-09L9 -2.57125e-09Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21L8 39",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrow);
export default __webpack_public_path__ + "static/media/line-arrow.3227879e579ae3c1e563c5587d63ed29.svg";
export { ForwardRef as ReactComponent };